import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class OrderHistoryDetails extends Mixins(CommonView) {
    // kurukuru: boolean = false;
    // pnkzList: {name: string, path: string | null}[] = [{name: "TOP", path: "/"}, {name: "マイページ", path: "/mypage"}, {name: "購入履歴", path: "/mypage/orderHistory"}, {name: "購入履歴詳細", path: null}];
    // public error: string = "";

    // public orderHistory: BASEAPI.OrderHistory | null = null;
    // public userPrizeList: BASEAPI.UserPrize[] = [];
    // public prizeList: {src: string, title: string}[] = [];
    // public visible: boolean = false;
    // public i: number | null = null;

    // public async created() {
    //     if (await this.isLoginRedirect(true)) return;
        
    //     await this.init();

    // }

    // @Watch('$route')
    // public async init() {
    //     if (await this.isLoginRedirect(true)) return;

    //     this.kurukuru = true;

    //     let orderHistoryId = Number(this.$route.params.no);
    //     if(!orderHistoryId) {
    //         this.$router.push("/");
    //         return;
    //     }

    //     let res = await BASEAPI.OrderHistoryController.getOrderHistoryUsingGET(orderHistoryId).catch(AxiosErrorHandler);
    //     if (isAxiosError(res)) {
    //         this.error = "" + res.data;
    //         this.kurukuru = false;
    //         return;
    //     }
    //     this.orderHistory = res.data;

    //     let resPrize = await BASEAPI.OrderHistoryPrizeController.getUserPrizeUsingGET(undefined, undefined, orderHistoryId).catch(AxiosErrorHandler);
    //     if (isAxiosError(resPrize)) {
    //         this.error = "" + resPrize.data;
    //         this.kurukuru = false;
    //         return;
    //     }
    //     resPrize.data.forEach(prize => {
    //         for(let i = 0; i < prize.count!; i++){
    //             this.userPrizeList.push({title: prize.title, image: prize.image, count: 1});
    //         }
    //     })

    //     this.userPrizeList?.forEach(prize => {
    //         this.prizeList.push({src: prize.image!, title: prize.title!});
    //     });

    //     this.kurukuru = false;
    // }

    // showImg (index: number) {
    //     this.i = index;
    //     this.visible = true;
    // }
    // handleHide () {
    //     this.visible = false;
    // }
}
